<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 15:11:59
 * @LastEditors: shenlin
 * @LastEditTime: 2021-11-09 09:26:03
-->
<template>
  <div class="app-container">
    <div class="videoContent">
      <div class="video">
        <video width="200px" height="180px" controls id="video1">
          <source :src="videoContent.videoUrl" type="video/mp4" />
          浏览器不支持 video 标签，建议升级浏览器。
        </video>
      </div>
      <div class="text">
        <div class="title">{{ videoContent.videoName }}</div>
        <div>视频简介：{{ videoContent.videoIntroduction }}</div>
        <div>视频类型：{{ videoContent.videoType }}</div>
        <div>上传者：{{ videoContent.creator }}</div>
        <div>上传时间：{{ videoContent.createTime }}</div>
      </div>
      <div class="bnt" v-if="videoContent.status == 0">
        <div @click="audit(2)">驳回</div>
        <div @click="audit(1)">通过</div>
      </div>
    </div>
    <div class="videoList">
      <div class="title">审核记录</div>
      <el-table
        :data="tableData"
        style="width: 100%"
        height="400"
        :header-cell-style="{ background: '#fafafa' }"
      >
        <el-table-column
          prop="creator"
          width="200px"
          label="审核人"
        ></el-table-column>
        <el-table-column prop="status" width="200px" label="审核状态">
          <template slot-scope="scope">
            <div>
              <span
                v-if="scope.row.status == 1"
                style="
                  width: 8px;
                  height: 8px;
                  background: green;
                  display: inline-block;
                  border-radius: 50%;
                "
              ></span>
              <span
                v-else-if="scope.row.status == 0"
                style="
                  width: 8px;
                  height: 8px;
                  background: #d8d8d8;
                  display: inline-block;
                  border-radius: 50%;
                "
              ></span>
              <span
                v-else
                style="
                  width: 8px;
                  height: 8px;
                  background: red;
                  display: inline-block;
                  border-radius: 50%;
                "
              ></span>
              {{ videoStatus(scope.row.status) }}
            </div>
          </template></el-table-column
        >
        <el-table-column
          prop="createTime"
          width="200px"
          label="操作时间"
        ></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="totalRecord"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="videoTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <span v-if="status !== 1">请填写驳回理由。</span>
      <span v-else>确认通过吗？</span>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="备注：" :prop="status !== 1 ? 'remark' : ''">
          <el-input type="textarea" v-model="ruleForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addVideoDataExam">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  VideoDetailsById,
  listVideoExam,
  addVideoDataExam,
} from '@api/video/video'
export default {
  name: 'Detail',
  data() {
    return {
      videoTitle: '通过',
      dialogVisible: false,
      videoContent: {
        id: this.$route.query.id,
        videoName: '',
        videoUrl: '',
        videoType: '',
        videoIntroduction: '',
        imageName: '',
        imageUrl: '',
        createTime: '',
        updateTime: '',
        creator: '',
        updater: '',
      },
      status: '',
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalRecord: 0,
      ruleForm: {
        remark: '',
      },
      rules: {
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
    }
  },
  computed: {
    videoStatus() {
      return (number) => {
        let val
        switch (number) {
          case 0:
            val = '待审核'
            break
          case 1:
            val = '通过'
            break
          case 2:
            val = '驳回'
            break
        }
        return val
      }
    },
  },
  created() {
    this.getVideoDetail()
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    /**
     * @name:获取视频详情信息
     * @test: test font
     * @msg:
     * @param {*}
     * @return {*}
     */
    getVideoDetail() {
      VideoDetailsById({ id: this.$route.query.id }).then((res) => {
        if (res.data.code == '0000') {
          this.videoContent = { ...res.data.data } || {}
          this.myPlyer = document.getElementById('video1')
          this.myPlyer.load()
          this.getListVideoExam()
        }
      })
    },
    /**
     * @name:获取审核记录列表
     * @test: test font
     * @msg:
     * @param {*}
     * @return {*}
     */
    getListVideoExam() {
      let params = {
        id: this.$route.query.id,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }
      listVideoExam(params).then((res) => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData = [...list.results] || []
          this.totalRecord = list.totalRecord || 0
        }
      })
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.getListVideoExam()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getListVideoExam()
    },
    /**
     * @name:视频审核驳回
     * @test: test font
     * @msg:
     * @param {*}
     * @return {*}
     */
    audit(index) {
      this.status = index
      this.videoTitle = this.status == 1 ? '通过' : '驳回'
      this.dialogVisible = true
    },
    /**
     * @name:视频审核或者驳回
     * @test: test font
     * @msg:
     * @param {*}
     * @return {*}
     */
    addVideoDataExam() {
      let data = {
        videoId: this.$route.query.id,
        status: this.status,
        remark: this.ruleForm.remark
      }
      addVideoDataExam(data).then((res) => {
        if (res.data.code == '0000') {
          this.$message.success(res.data.msg)
          this.ruleForm.remark = ''
          this.dialogVisible = false
          this.getVideoDetail()
          this.getListVideoExam()
        } else {
          this.$message(res.data.msg)
          this.ruleForm.remark = ''
          this.dialogVisible = false
        }
      })
    }
  }
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
.app-container {
  overflow-y: auto;
  .videoContent {
    display: flex;
    & > .video {
      // border: 1px solid;
    }
    & > .text {
      width: 60%;
      margin-left: 30px;
      & > .title {
        font-size: 16px;
        color: rgba($color: #000000, $alpha: 1);
      }
      & > div {
        font-size: 14px;
        color: rgba($color: #000000, $alpha: 0.7);
        margin-bottom: 15px;
      }
    }
    & > .bnt {
      display: flex;
      div {
        font-size: 18px;
        cursor: pointer;
        height: 32px;
        line-height: 32px;
        margin-right: 20px;
        padding: 0 15px;
        color: rgb(192, 14, 14);
        border: 1px solid rgb(192, 14, 14);
        &:nth-child(2) {
          color: #1890ff;
          border: 1px solid #1890ff;
        }
      }
    }
  }
  .videoList {
    margin-top: 20px;
    & > .title {
      font-size: 16px;
      margin: 20px 0;
    }
    .table-page {
      width: 100%;
      text-align: center;
      margin-top: 24px;
      margin-bottom: 20px;
    }
  }
  /deep/ .el-dialog__wrapper {
    .el-dialog__header {
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    }
    .el-dialog__footer {
      border-top: 1px solid rgba(0, 0, 0, 0.2);
    }
    .el-form {
      margin-top: 30px;
    }
  }
}
</style>
